module.exports = __webpack_public_path__ + "img/752-a576db.png";